import { TimePeriod } from '../TimePeriod';

interface MappedWithTimePeriod<T> {
    timePeriod: TimePeriod;
    value: T;
}

export class MappedTimePeriodArray<T> {
    public constructor(public readonly internalMap: Array<MappedWithTimePeriod<T>>) {}

    public get length(): number {
        return this.internalMap.length;
    }

    public filter<S extends T>(filterFunc: (value: T) => value is S): MappedTimePeriodArray<S> {
        return new MappedTimePeriodArray(
            this.internalMap.filter((withTp): withTp is MappedWithTimePeriod<S> => filterFunc(withTp.value)),
        );
    }

    public map<U>(mappingFunc: (value: T) => U): MappedTimePeriodArray<U> {
        return new MappedTimePeriodArray(
            this.internalMap.map(val => ({
                timePeriod: val.timePeriod,
                value: mappingFunc(val.value),
            })),
        );
    }

    public values(): T[] {
        return this.internalMap.map(val => val.value);
    }
}
